<template>
    <QitButton
        padding="sm"
        :icon="isXSmall ? mobileIcon : icon"
        size="13px"
        data-qs="show-info-menu-button"
        class="grey-hover"
        color="none"
    >
        <q-menu v-model="show">
            <q-list dense>
                <q-item clickable v-for="staticPage in staticPages" :key="staticPage.key">
                    <q-item-section :data-qs="`static-pages-${staticPage.key}`">
                        <router-link :to="staticPage.to">
                            {{ staticPage.title }}
                        </router-link>
                    </q-item-section>
                </q-item>
            </q-list>
        </q-menu>
        <q-tooltip>{{ $t("shared.Info") }}</q-tooltip>
    </QitButton>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useScreenSize } from "@/shared/screen/composables/screen-size";
import { StaticPage } from "@/shared/composables/static-pages";
import QitButton from "@/shared/components/buttons/qit-button.vue";

const show = ref(false);

defineProps<{
    menuTitleTranslationKey: string;
    icon: string;
    mobileIcon: string;
    staticPages: StaticPage[];
}>();

const { isXSmall } = useScreenSize();
</script>
